/* QRISTALINO MX v2 — WhatsApp con contexto + código de atención + atribución (Meta/Google/gclid)
   Configuración centralizada en layout/theme.liquid (window.QZ_WA_PHONE ← settings.whatsapp_number; window.QZ_HOOK ← settings.qz_make_hook). */
(function () {
  var PHONE = String(window.QZ_WA_PHONE || '').replace(/\D/g, '');
  var HOOK = String(window.QZ_HOOK || '').trim();
  var STORE = 'qz_attr', CODE_KEY = 'qz_code', TTL = 90 * 24 * 60 * 60 * 1000; /* 90 días: ventana de conversión de Google Ads */
  if (!PHONE) { try { console.warn('[Qristalino MX] settings.whatsapp_number vacío — [PENDIENTE: número WhatsApp México]'); } catch (e) {} }

  function param(n) { try { return new URLSearchParams(location.search).get(n) || ''; } catch (e) { return ''; } }
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function cookie(k, v, days) {
    try {
      if (v === undefined) { var m = document.cookie.match(new RegExp('(?:^|; )' + k + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; }
      var d = new Date(); d.setTime(d.getTime() + days * 864e5);
      document.cookie = k + '=' + encodeURIComponent(v) + '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax; Secure';
    } catch (e) { return ''; }
  }

  var a = {
    utmSource: param('utm_source'), utmMedium: param('utm_medium'), utmCampaign: param('utm_campaign'),
    utmContent: param('utm_content'), utmTerm: param('utm_term'),
    campaignId: param('meta_campaign_id'), adsetId: param('meta_adset_id'), adId: param('meta_ad_id'), adsetName: param('meta_adset_name'),
    fbclid: param('fbclid'), gclid: param('gclid'), gbraid: param('gbraid'), wbraid: param('wbraid'), msclkid: param('msclkid'),
    landing: location.pathname + location.search, referrer: document.referrer || '', firstSeen: new Date().toISOString()
  };
  var hasParams = a.adId || a.utmContent || a.utmCampaign || a.gclid || a.gbraid || a.wbraid || a.fbclid || a.utmSource;
  try {
    if (hasParams) { ls(STORE, JSON.stringify({ t: Date.now(), a: a })); if (a.gclid) cookie('qz_gclid', a.gclid, 90); }
    else { var raw = ls(STORE); if (raw) { var s = JSON.parse(raw); if (s && s.t && Date.now() - s.t < TTL && s.a) a = s.a; } }
    if (!a.gclid) { var cg = cookie('qz_gclid'); if (cg) a.gclid = cg; }
  } catch (e) {}

  function adCode(name) {
    if (!name) { if (a.gclid || a.gbraid || a.wbraid) return 'GADS'; if (a.fbclid) return 'META'; return 'WEB'; }
    var first = String(name).trim().split(/[\s_·|-]+/)[0] || '';
    first = first.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
    return first.slice(0, 8) || 'WEB';
  }
  function suffix() {
    var A = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789', s = '', r = new Uint8Array(5);
    if (window.crypto && crypto.getRandomValues) crypto.getRandomValues(r); else for (var j = 0; j < 5; j++) r[j] = Math.floor(Math.random() * 256);
    for (var i = 0; i < 5; i++) s += A[r[i] % A.length];
    return s;
  }
  var code = ls(CODE_KEY);
  if (!code) { code = 'MX-' + adCode(a.utmContent) + '-' + suffix(); ls(CODE_KEY, code); }
  window.QZ_CODE = code;
  document.querySelectorAll('[data-qz-code]').forEach(function (el) { el.textContent = code; });

  function device() {
    var u = navigator.userAgent || '';
    if (/iPad|Tablet|PlayBook|Silk|(Android(?!.*Mobile))/i.test(u)) return 'Tablet';
    if (/Mobi|Android|iPhone|iPod|IEMobile|Opera Mini/i.test(u)) return 'Móvil';
    return 'Escritorio';
  }

  function buildHref(msg) {
    var full = msg + ' Código: ' + code;
    return 'https://wa.me/' + PHONE + '?text=' + encodeURIComponent(full);
  }
  function register(el) {
    var payload = {
      pais: 'MX', codigo: code, codigoAnuncio: code.split('-')[1] || '',
      anuncio: a.utmContent, conjunto: a.adsetName, campana: a.utmCampaign, adId: a.adId, adsetId: a.adsetId, campaignId: a.campaignId,
      utmSource: a.utmSource, utmMedium: a.utmMedium, utmCampaign: a.utmCampaign, utmContent: a.utmContent, utmTerm: a.utmTerm,
      gclid: a.gclid, gbraid: a.gbraid, wbraid: a.wbraid, fbclid: a.fbclid, msclkid: a.msclkid,
      landing: a.landing, landingActual: location.href, referrer: a.referrer, primeraVisita: a.firstSeen,
      pagina: document.body.getAttribute('data-qz-page') || '', producto: el.getAttribute('data-qz-product') || '', coleccion: el.getAttribute('data-qz-collection') || '',
      boton: el.getAttribute('data-qz-source') || '', dispositivo: device(),
      pantalla: (screen ? screen.width + 'x' + screen.height : ''), idioma: navigator.language || '', ua: navigator.userAgent || '', ts: new Date().toISOString()
    };
    var body = JSON.stringify(payload);
    if (HOOK) {
      try {
        if (navigator.sendBeacon) navigator.sendBeacon(HOOK, new Blob([body], { type: 'text/plain;charset=UTF-8' }));
        else fetch(HOOK, { method: 'POST', mode: 'no-cors', keepalive: true, body: body });
      } catch (e) {}
    }
    try {
      var first = !ls('qz_wa_sent');
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: first ? 'whatsapp_click' : 'whatsapp_click_repeat',
        qz_code: code, qz_gclid: a.gclid || '', qz_page: payload.pagina, qz_product: payload.producto, qz_collection: payload.coleccion, qz_source: payload.boton, qz_country: 'MX'
      });
      if (first) ls('qz_wa_sent', code);
    } catch (e) {}
  }
  function wire(root) {
    (root || document).querySelectorAll('a[data-qz-msg]').forEach(function (el) {
      if (el.__qz) return; el.__qz = true;
      el.setAttribute('href', buildHref(el.getAttribute('data-qz-msg')));
      el.setAttribute('target', '_blank'); el.setAttribute('rel', 'noopener nofollow');
      el.addEventListener('click', function () { el.setAttribute('href', buildHref(el.getAttribute('data-qz-msg'))); register(el); });
    });
  }
  wire(document);
  document.addEventListener('shopify:section:load', function (e) { wire(e.target); });
  new MutationObserver(function () { wire(document); }).observe(document.documentElement, { childList: true, subtree: true });

  var bar = document.querySelector('[data-q-sticky-atc]');
  if (bar) {
    var anchor = document.querySelector('.qz-pdp-wa') || document.querySelector('.main-product__block-buy_buttons');
    var toggle = function () {
      if (!anchor) return;
      var r = anchor.getBoundingClientRect();
      bar.classList.toggle('is-visible', r.bottom < 0 || r.top > window.innerHeight);
    };
    window.addEventListener('scroll', toggle, { passive: true }); toggle();
    var btn = bar.querySelector('[data-q-sticky-button]');
    if (btn) btn.addEventListener('click', function () {
      var atc = document.querySelector('.main-product__block-buy_buttons .m-add-to-cart');
      if (atc) { atc.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    });
  }
})();
